import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'
import Loading from '../../../components/Loading';
import DropdownSearch from '../../../components/DropdownSearch';
import Modal from '../../../components/Modal';
import TextArea from '../../../components/TextArea';
import AudioPlayer from '../../../components/AudioPlayer';
import InputText from "../../../components/InputText";

import polly_icon from '../../../assets/vw/svg/PollyTabsGrey.svg';
import polly_icon_active from '../../../assets/vw/svg/PollyTabsBlue.svg';
import ARCH from '../../../assets/vw/svg/archivo.svg';
import ARCH_ACTIVE from '../../../assets/vw/svg/archivo_azul.svg';
import download_icon from "../../../assets/vw/svg/download.svg";
import eliminar_icon from "../../../assets/vw/svg/eliminar_azul.svg";
import save_icon from "../../../assets/vw/svg/save.svg";
import cerrar from "../../../assets/vw/svg/cerrar.svg";

const inputPollyInitial = {
  texto: "",
  voz: "",
  lenguaje: "",
  motor: "generative"
}

const audioInitial = {
  audio:"",
  nombreArchivo:"",
  idapp:""
}

function extractBackendMessage(data) {
  if (!data) return null;

  if (typeof data === 'string') {
    try {
      const parsedData = JSON.parse(data);
      return extractBackendMessage(parsedData);
    } catch {
      return data;
    }
  }

  if (data.mensaje) {
    return extractBackendMessage(data.mensaje);
  }

  if (data.body) {
    return extractBackendMessage(data.body);
  }

  return null;
}

async function getResponseData(response) {
  const responseText = await response.text();

  if (!responseText) {
    return null;
  }

  try {
    return JSON.parse(responseText);
  } catch {
    return responseText;
  }
}

function Polly({servicio}) {
  const backendUrl = process.env.REACT_APP_URL_DTO_BACK;
  const [hoveredOption, setHoveredOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [option, setOption] = useState("polly");
  const [inputPolly, setInputPolly] = useState(inputPollyInitial);
  const [allVoces, setAllVoces] = useState([]);
  const [voces, setVoces] = useState([]);
  const [vocesExactas, setVocesExactas] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [audioSave, setAudioSave] = useState(audioInitial);
  const [audio, setAudio] = useState("");
  const [audioBase64, setAudioBase64] = useState("");

  const [aplicaciones, setAplicaciones] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [modal, setModal] = useState({
      active: false,
      message: '',
      success: false,
      tryAgain: false
    }); 

  useEffect(() => {
    fetchVoces()
    getAplicaciones();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (inputPolly.lenguaje) {
      // Filtrar las voces según el lenguaje seleccionado
      const vocesFiltradas = voces.filter((voz) => {
        return (
          voz.lenguaje === inputPolly.lenguaje &&
          voz.motorCompatible.includes('generative')
        );
      });
      setVocesExactas(vocesFiltradas);
    } else {
      setVocesExactas([]); // Si no hay lenguaje seleccionado, limpiar voces
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputPolly.lenguaje, idiomas]);

  useEffect(() => {
    const lenguajesUnicos = voces.reduce((acc, voz) => {
      const { idioma, lenguaje } = voz;
      if (!acc.some((item) => item.idioma === idioma && item.lenguaje === lenguaje)) {
        acc.push({ idioma, lenguaje, motor: voz.motorCompatible });
      }
      return acc;
    }, []); 

    setIdiomas(lenguajesUnicos);
  },[voces]);

  useEffect(() => {
    // Filtrar las voces según el lenguaje seleccionado
    const vocesFiltradas = allVoces.filter((voz) => 
      voz.motorCompatible.includes(inputPolly.motor)
    );
    setVoces(vocesFiltradas);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allVoces]);

  async function fetchVoces() {
    setIsLoading(true);
    try {
      const response = await fetch(backendUrl + 'multimedia/getvoces', {
        method: "GET",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json"
        },
      });

      const data = await getResponseData(response);

      if (response.status === 504) {
        setModal({
          active: true,
          message: "Tiempo de espera agotado",
          success: false,
          tryAgain: true
        });
        return;
      }

      if (!response.ok) {
        throw new Error(extractBackendMessage(data) || 'Error al recibir la respuesta del servidor');
      }

      if (response.status === 200) {
        const vocesData = data.mensaje
        setAllVoces(vocesData);
      } else {
        setModal({
          active: true,
          message: extractBackendMessage(data) || 'Error al recibir la respuesta del servidor',
          success: false
        });
      }
      
    } catch (error) {
      console.error(error.stack || error);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setIsLoading(false);
    }
  }

  async function getAplicaciones() {
    setIsLoading(true);
    setModal({
      active: false,
      message: '',
      success: false
    });
    try {
      const response = await fetch(backendUrl + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
      });

      const data = await getResponseData(response);

      if (!response.ok) {
        throw new Error(extractBackendMessage(data) || 'Error al recibir la respuesta del servidor');
      }
      setAplicaciones(data.mensaje);
    } catch (error) {
      console.error(error.stack || error);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setIsLoading(false);
    }
  }

  function buildQueryParams () {
    const queryParams = [];
    const params = {...inputPolly}
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = encodeURIComponent(params[key]);

        if (value !== "") {
          queryParams.push(`${key}=${value}`);
        }
      }
    }
    const queryParamsString = queryParams.join("&");
    return queryParamsString;
  }

  async function generarAudio() {
    const queryParams = buildQueryParams();
    setIsLoading(true);
    try {
      const response = await fetch(backendUrl +'multimedia/gettextoaudio?'+ queryParams, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        }
      });

      const data = await getResponseData(response);

      if (response.status === 504) {
        setModal({
          active: true,
          message: "Tiempo de espera agotado",
          success: false,
          tryAgain: true
        });
        return;
      }

      if (!response.ok) {
        throw new Error(extractBackendMessage(data) || 'Error al recibir la respuesta del servidor');
      }

      if (response.status === 200) {
        const base64Audio = data.mensaje.audio;
        setAudioBase64(base64Audio);

        // Convierte el base64 a un Blob tipo audio/mpeg
        const byteCharacters = atob(base64Audio);
        const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'audio/mpeg' });

        // Crea una URL temporal que puedes usar como src
        const audioUrl = URL.createObjectURL(blob);
        setAudio(audioUrl);
      } else {
        setModal({
          active: true,
          message: extractBackendMessage(data) || 'Error al recibir la respuesta del servidor',
          success: false
        });
      }
      
    } catch (error) {
      console.error(error.stack || error);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setIsLoading(false);
    }
  }

  function disabled_generar() {
    return inputPolly.texto === "" || inputPolly.voz === "" || inputPolly.lenguaje === "";
  }

  function disabled_guardar() {
    return audioSave.nombreArchivo === "" || audioSave.idapp === "" || audioSave.audio === "";
  }
  function quitarAcentos(cadena) {
    return cadena.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function handleDownload() {
    if (audio) {
      const link = document.createElement('a');
      link.href = audio;
      link.download = 'audioPolly.mp3';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  function handleDelete() {
    setModal({
      active: true,
      message: "¿Estás seguro de eliminar el audio?",
      success: false,
      tryAgain: true,
      options: true,
      tryAgainText: "Eliminar",
      isDelete: true,
      onclickParam: deleteInput
    })
  }

  function deleteInput() {
    setInputPolly(inputPollyInitial);
    setAudio(null);
    window.location.reload();
  }
  function handleSave() {
    setMostrarModal(true);
    setAudioSave({
      ...audioSave,
      audio: audioBase64 
    });
  }

  async function sendAudio(e) {
    e.preventDefault();
    setIsLoading(true);
    setModal({
      active: false,
      message: '',
      success: false
    });
    try {
      const aux = inputPolly.texto
      ? inputPolly.texto.split(" ").slice(0, Math.min(3, inputPolly.texto.split(" ").length)).join(" ")
      : "";
      const response = await fetch(backendUrl + 'multimedia/subiraudio', {
        method: "POST",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          audio: audioSave.audio,
          nombreArchivo: audioSave.nombreArchivo + aux,
          idapp: audioSave.idapp
        })
      });

      const data = await getResponseData(response);

      if (response.status === 504) {
        setModal({
          active: true,
          message: "Tiempo de espera agotado",
          success: false,
          tryAgain: true
        });
        return;
      }

      if (!response.ok) {
        throw new Error(extractBackendMessage(data) || 'Error al recibir la respuesta del servidor');
      }

      if (response.status === 200) {
        setModal({
          active: true,
          message: "Audio guardado correctamente",
          success: true,
          tryAgain: true,
          options: false,
          tryAgainText: "Aceptar",
          onclickParam: () => {
            setModal({
              active: false,
              message: '',
              success: false
            });
            window.location.reload();
          }
        });
        setMostrarModal(false);
        setAudioSave(audioInitial);
        setInputPolly(inputPollyInitial);
        setAudio(null);
        
      } else {
        setModal({
          active: true,
          message: extractBackendMessage(data) || 'Error al recibir la respuesta del servidor',
          success: false
        });
      }
      
    } catch (error) {
      console.error(error.stack || error);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setIsLoading(false);
    }
  }


  const buildModalSave = () => {
    return (
      mostrarModal && (
      <div
        className={`modal modal_vw fade ${mostrarModal ? "show" : ""}`}
        id="modal"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal_lg_vw "
          role="document"
        >
          <div className="modal-content modal_content-vw p-0 p-lg-2">
            <div className="modal-header modal_header-vw py-lg-0">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setMostrarModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <form className={"position-relative"} onSubmit={sendAudio}>
              <div  className={`modal-body mx-3 mx-sm-4 mx-lg-5 p-0 mb-2 mb-sm-4 mb-lg-0 position-static`}>
                <div className="modal-title-container d-flex justify-content-start titulo pb-2">
                  <span className={"modal-title-principal-text"}>Guardar audio</span>
                </div>
                <div className=" border_vw"></div>
                
                <div className='col-12 d-flex p-0 mt-4 mb-4 gap-2'>
                  <div className='col-6 p-0'>
                    <InputText
                      inputLabel={"Nombre del audio"}
                      id={"nombreArchivo"}
                      inputField={audioSave.nombreArchivo}
                      changingInput={(event) => {
                        setAudioSave({
                          ...audioSave,
                          nombreArchivo: event.target.value
                        });
                      }}
                      required={true}
                    />
                  </div>
                  <div className='col-6 p-0'>
                      <DropdownSearch
                        menu={aplicaciones}
                        title={"Proyecto"}
                        defaultValue={audioSave.idapp}
                        handleOptionSelected={(e) => {
                          setAudioSave({
                            ...audioSave,
                            idapp: e.props.value   
                          });
                        }}
                        fieldID={'nombre'}
                        fieldToShow={'nombre'}
                      />
                  </div>
                </div>
              </div>

              <div className="modal-footer footer_modal_vw d-flex justify-content-center justify-content-lg-end gap-2 gap-sm-3 gap-lg-2 px-0 mx-3 mx-lg-5 mb-2 mb-lg-0">
                <button
                  type="button"
                  className="button_vw button_vw--secondary order-2 order-sm-1"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setMostrarModal(false);
                    setAudioSave(audioInitial);
                  }}
                >
                  Cancelar
                </button>

                <button
                  type="submit"
                  className="button_vw button_vw--primary order-1 order-sm-2"
                  data-bs-dismiss="modal"
                  disabled={disabled_guardar()}
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>)
    );
  };

  return (
    <>
      <Menu />
      <Modal modalInfo={modal} setMostrarModal={setModal} />
      {
        isLoading && <Loading />
      }
      <div className={`navegacion`}>
        <div className=" posicionMenu">
          <ul className="d-flex flex-row px-0 my-0">
            <li
              className="opcion-ruta"
              onClick={() => setOption("polly")}
              onMouseEnter={() => setHoveredOption("polly")}
              onMouseLeave={() => setHoveredOption(null)}
            >
              <div
                className={`nav-link nav-link-title active ps-0 ${
                  option === "polly" ? " active border_menu" : ""
                }`}
              >
                <img
                  src={hoveredOption === "polly" || option === "polly"
                    ? polly_icon_active
                    : polly_icon
                  } 
                  alt="polly"
                  className="icono-menu me-3"
                />
                Polly
              </div>
            </li>
            <li
              className="opcion-ruta"
              onClick={() => setOption("archivo")}
              onMouseEnter={() => setHoveredOption("archivo")}
              onMouseLeave={() => setHoveredOption(null)}
            >
              <div
                className={`nav-link active ps-0  ${
                  option === "archivo" ? " active border_menu" : ""
                }`}
              > 
                <img 
                  src={
                    hoveredOption === "archivo" || option === "archivo"
                      ? ARCH_ACTIVE
                      : ARCH
                  }
                  alt="archivo" 
                  className="icono-menu me-3" 
                />
                Archivo
              </div>
            </li>
          </ul>
        </div>
        <div className="row  border_vw pt-4 ms-0 mx-0">
          <div className="col-12 p-0 contenedor-table">
            {option === "archivo" ? (
              <> 
                {/* <TablaArchivo
                  data={
                    filteredConcesionariasInactivas &&
                    filteredConcesionariasInactivas.length > 0
                      ? filteredConcesionariasInactivas
                      : concesionariasInactivas
                  }
                  servicio={props.servicio}
                  handleChange={handleChange}
                /> */}
                <div>
                  archivo
                </div>
              </>
            ) : (
              <>
                <div className="polly-container">
                  <div className="mb-4">
                    <h3 className="title-polly">
                      Contenido
                    </h3>
                  </div>
                  <div className="options-polly d-flex flex-column flex-md-row col-12 p-0 gap-2 gap-md-0">
                    <div className='col-12 col-md-6 p-0 pr-md-2'>
                      <DropdownSearch
                        menu={idiomas}
                        title={"Lenguaje"}
                        defaultValue={inputPolly.lenguaje}
                        handleOptionSelected={(e) => {
                          setInputPolly({
                            motor: inputPolly.motor,
                            voz: "",
                            texto: inputPolly.texto,
                            lenguaje: e.props.value,
                          });
                        }}
                        fieldID={'lenguaje'}
                        fieldToShow={'idioma'}
                      />
                    </div>
                    <div className='col-12 col-md-6 p-0 pl-md-2'>
                      <DropdownSearch
                        menu={vocesExactas}
                        title={"Voz"}
                        defaultValue={inputPolly.voz}
                        handleOptionSelected={(e) => {
                          setInputPolly({
                            ...inputPolly,
                            voz: quitarAcentos(e.props.value),
                          });
                        }}
                        fieldID={'nombre'}
                        fieldToShow={'nombre'}
                      />
                    </div>
                  </div>
                  <div className='input-polly col-12 p-0 '>
                    <TextArea
                      inputLabel="Texto to Speech"
                      inputField={inputPolly.texto}
                      id="texto"
                      changingInput={(e) => setInputPolly({
                        ...inputPolly,
                        texto: e.target.value,
                      })}
                      required
                      rows={8}
                      placeholder={"Ingresa el texto para sintetizar..."}
                    />
                  </div>
                  
                    
                  <div className={`'col-12 d-flex align-items-center ${audio ? " justify-content-end ":" justify-content-between "} '`}>
                    
                    <div className='col-10 p-0'>
                      {audio && (
                        <div className='audio-container-polly col-12 rounded'>
                          <div className='audio-player p-0'>
                            <AudioPlayer audioSrc={audio} />
                          </div>
                          <div className='save-audio-container'> 
                            <div className='col-12 d-flex justify-content-between w-100 h-100 p-0'>
                              <div className='contain p-0'>
                                <button
                                  type="button"
                                  className={" btn-transparent "}
                                  onClick={handleDownload}
                                >
                                  <img src={download_icon} alt="mas" className=""/>
                                </button>
                              </div>
                              <div className='contain p-0'>
                                <button
                                  type="button"
                                  className={" btn-transparent "}
                                  onClick={handleDelete}
                                >
                                  <img src={eliminar_icon} alt="mas" className=""/>
                                </button>
                              </div>
                              <div className='contain p-0'>
                                <button
                                  type="button"
                                  className={" btn-transparent "}
                                  onClick={handleSave}
                                >
                                  <img src={save_icon} alt="mas" className=""/>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    
                    <div className='col-2 d-flex justify-content-end p-0'>
                      <button
                        type="button"
                        className="button_vw button_vw--primary m-0 "
                        onClick={()=>{
                          setInputPolly({
                            ...inputPolly,
                            motor: 'generative'
                          });
                          generarAudio()
                          //setAudio(prueba); // Para pruebas, se puede eliminar esta línea
                        }}
                        disabled={disabled_generar()}
                        data-track-click="btn-generar-audio"
                      >
                        Generar audio
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {buildModalSave()}
    </>
  )
}

export default Polly
